import { getFetch, postFetch, putFetch, deleteFetch } from '../utils/fetch';
import { ENVIRONMENT_PROTECT_WORK_ATTACHMENT_API } from './config';

export function getList(query) {
  return getFetch(`${ENVIRONMENT_PROTECT_WORK_ATTACHMENT_API()}`, query);
}

export function getOne(_id) {
  return getFetch(`${ENVIRONMENT_PROTECT_WORK_ATTACHMENT_API()}/${_id}`);
}

export function updateOne(_id, data = {}) {
  return putFetch(`${ENVIRONMENT_PROTECT_WORK_ATTACHMENT_API()}/${_id}`, data);
}

export function deleteOne(_id) {
  return deleteFetch(`${ENVIRONMENT_PROTECT_WORK_ATTACHMENT_API()}/${_id}`);
}

export function create(obj) {
  return postFetch(`${ENVIRONMENT_PROTECT_WORK_ATTACHMENT_API()}`, obj);
}



// WEBPACK FOOTER //
// ./src/api/environmentProtectionWorkAttachmentApi.js